import { Row, Table } from '@tanstack/react-table';
import { Checkbox } from '../../atomic/input/checkbox';

type TableRowSelectorProps<T> = {
  // Entweder eine Tabelle oder eine Zeile
  table?: Table<T>;
  row?: Row<T>;
  // Optionale Props für das Styling oder zusätzliche Eigenschaften
  className?: string;
  disabled?: boolean;
  label?: string;
  color?: 'primary' | 'secondary';
  // Wenn true, werden nur die sichtbaren (gefilterten) Zeilen ausgewählt, statt alle Zeilen
  pageOnly?: boolean;
};

/**
 * Wiederverwendbare Komponente für die Auswahl von Tabellenzeilen
 * Kann entweder mit einer Tabelle (für "select all") oder mit einer Zeile verwendet werden
 */
export const TableRowSelector = <T,>({
  table,
  row,
  className,
  disabled,
  label,
  color,
  pageOnly = true // Standardmäßig nur sichtbare Zeilen auswählen
}: TableRowSelectorProps<T>) => {
  // Wenn eine Tabelle gegeben ist (für Header-Checkbox / "select all")
  if (table) {
    if (pageOnly) {
      // Nur sichtbare (gefilterte) Zeilen auswählen
      return (
        <Checkbox
          checked={table.getIsAllPageRowsSelected()}
          indeterminate={table.getIsSomePageRowsSelected()}
          onChange={table.getToggleAllPageRowsSelectedHandler()}
          className={className}
          disabled={disabled}
          label={label}
          color={color}
        />
      );
    } else {
      // Alle Zeilen auswählen (auch die nicht sichtbaren)
      return (
        <Checkbox
          checked={table.getIsAllRowsSelected()}
          indeterminate={table.getIsSomeRowsSelected()}
          onChange={table.getToggleAllRowsSelectedHandler()}
          className={className}
          disabled={disabled}
          label={label}
          color={color}
        />
      );
    }
  }

  // Wenn eine Zeile gegeben ist (für Zeilen-Checkbox)
  if (row) {
    return (
      <Checkbox
        checked={row.getIsSelected()}
        onChange={row.getToggleSelectedHandler()}
        className={className}
        disabled={disabled}
        label={label}
        color={color}
      />
    );
  }

  // Wenn weder Tabelle noch Zeile gegeben sind
  return null;
};
